module.exports = __webpack_public_path__ + "images/emoji/whale.2cea9c7a1f92da7848e0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/whale.png
// module id = g4Fz
// module chunks = 24